import Edition1Cover from '../assets/images/Art_Book_Cover_Edition_1.jpg';
import Edition2Cover from '../assets/images/Art_Book_Cover_Edition_2.jpg';
import { Routes } from './Routes';

export interface ArtBook {
  id: string;
  title: string;
  coverImage: string;
  route: string;
  featured?: boolean;
}

export const ArtBookData: ArtBook[] = [
  {
    id: 'edition-1',
    title: 'Unspoken Art Edition I',
    coverImage: Edition1Cover,
    route: `${Routes.ArtPublication}?edition=1`,
    featured: true,
  },
  {
    id: 'edition-2',
    title: 'Unspoken Art Edition II',
    coverImage: Edition2Cover,
    route: `${Routes.ArtPublication}?edition=2`,
    featured: false,
  },
];
